import React from 'react';
import { Outlet } from 'react-router-dom';

// El router controla la identidad por ruta, sin claves del historial.
const RouteAwareOutlet = () => <Outlet />;

export default RouteAwareOutlet;
